export default __webpack_public_path__ + "static/media/logoweb824.553bb61b.png";